import React from "react"
import { gql } from "~/__generated__"
import { useDocumentTitle } from "~/common/use-document-title"
import { useSafeMutation } from "~/common/use-safe-mutation"
import { Button } from "~/ui/button"
import { useToast } from "~/ui/use-toast"
import Text from "~/ui/typography"

const stripeConnectOnboardingLinkCreateMutation = gql(/* GraphQL */ `
  mutation StripeConnectOnboardingLinkCreateFromRefresh {
    stripeConnectOnboardingLinkCreate(input: {}) {
      url
    }
  }
`)

export const StripeOnboardingRefreshScreen: React.FC = () => {
  useDocumentTitle("Stripe onboarding")
  const { toast } = useToast()

  const [createLink, { loading }] = useSafeMutation(stripeConnectOnboardingLinkCreateMutation, {
    onCompleted: (data) => {
      const url = data.stripeConnectOnboardingLinkCreate.url
      window.location.assign(url)
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      })
    },
  })

  return (
    <div className="mx-auto mt-10 max-w-2xl space-y-4 p-8">
      <Text as="h1" className="text-2xl">
        Stripe onboarding
      </Text>
      <Text className="text-gray-400">
        Your onboarding session expired or was interrupted. Click below to restart.
      </Text>
      <Button type="button" onClick={() => createLink()} disabled={loading}>
        {loading ? "Starting..." : "Restart Stripe onboarding"}
      </Button>
    </div>
  )
}
